export class IBRModel {
    buyPriceInINR: number;
    buyPriceInUSD: number;
    createdAt: string;
    currencyCode: string;
    currencyName: string;
    id: string;
    partnerId: string;
    product: string;
    salePriceInINR: number;
    salePriceInUSD: number;
    updatedAt: string;
    userId: string;
    validFrom: string;
    validTill: string;

    //custom
    isCustomeRate: boolean
    editMode: boolean;
    tempBuyPriceInINR: number;
    tempSalePriceInINR: number;
}

export class IBRHistoryModel {
    action: string;
    buyPriceInINR: number;
    createdAt: string;
    currencyCode: string;
    id: string;
    salePriceInINR: number;
    updatedAt: string;
    userId: string;
}


// WEBPACK FOOTER //
// ./src/app/_models/rates/IBRModel.ts